import { GraftConfig as WorkspacesGraftConfig } from '@graft/nuget-gc.webportals.workspaces'

import { readGraftWebserviceUrl } from '@common/config/utils/read-graft-webservice-url.util'

const workspacesUrl = readGraftWebserviceUrl('WORKSPACES')

if (workspacesUrl) {
  WorkspacesGraftConfig.host = workspacesUrl
  WorkspacesGraftConfig.stateless = true
}
